export default __webpack_public_path__ + "static/media/focus_topics.3e6f8a63.svg";